module.exports = __webpack_public_path__ + "static/media/_MIC2521.thumbnail.2c0b5f90.png";